import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastSubject = new Subject<{ title: string; message: string; type: 'success' | 'error' | 'info'; duration: number }>();
  toastState = this.toastSubject.asObservable();

  /**
   * Displays a toast notification
   * @param title The title of the toast
   * @param message The message of the toast
   * @param type The type of toast ('success', 'error', 'info')
   * @param duration Duration in milliseconds
   */
  showToast(title: string, message: string, type: 'success' | 'error' | 'info' = 'success', duration = 3000) {
    this.toastSubject.next({ title, message, type, duration });
  }
}
